module.exports = __webpack_public_path__ + "img/A2000.8dfc5905.png";